import { render, staticRenderFns } from "./AddBays.vue?vue&type=template&id=e66bfba4&"
import script from "./AddBays.vue?vue&type=script&lang=js&"
export * from "./AddBays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports